import React, { Component } from 'react';
import p5 from 'p5';

//import ParticleSystem from './ParticleSystems';
//import BrokenPeices from './BrokenPeices';
import FireWork from './FireWork';

class Home extends Component {
	constructor() {
		super();
		this.myP5 = null;
		this.canvasRef = React.createRef();

		this.sketch = (p) => {
			let fireworks = [];

			p.setup = () => {
				let divInfo = document
					.getElementById('home-wrapper')
					.getBoundingClientRect();
				let divW = divInfo.width;
				let divH = divInfo.height;
				p.createCanvas(divW, divH).parent(this.canvasRef.current);
				p.noFill();
				p.stroke(200);
				for (let i = 0; i < 30; i++) {
					fireworks.push(new FireWork(p));
				}
				p.background(255);
			};

			p.draw = () => {
				//p.background(255);
				p.background(255, 70);

				for (let i = 0; i < fireworks.length; i++) {
					fireworks[i].update();
					fireworks[i].show(p.mouseX, p.mouseY);

					for (let j = 0; j < fireworks.length; j++) {
						if (i !== j && fireworks[i].intersects(fireworks[j])) {
							fireworks[i].explode();
							fireworks[i].fireWork.pos = p.createVector(
								p.random(p.width),
								p.random(10) + p.height
							);
							fireworks[j].fireWork.pos = p.createVector(
								p.random(10) + p.width,
								p.random(p.height)
							);
							break;
						}
					}
				}
				//console.log(broken.length);
			};
		};
	}
	componentDidMount() {
		//console.log('mount')
		this.myP5 = new p5(this.sketch);
	}
	render() {
		return (
			<div id='home-wrapper' className='home-wrapper'>
				<div ref={this.canvasRef} className='canvas-ref'></div>
				<div className='container align-middle'>
					<div className='row mycustom-jumbotron'>
						<div className='col-5'>
							<img
								className='img-home'
								src='/images/DK_home_pic1.jpg'
								alt='DK'
								width='460'
								height='345'
							/>
							<div>
								<b>Debajyoti Karmaker</b>
							</div>
						</div>
						<div className='col-7 text-right'>
							<div className='link-container'>
								<a href='https://github.com/debajyotikarmaker'>
									<i className='fab fa-github fa-2x'></i>
								</a>
								<a href='https://scholar.google.com/citations?user=7sHKEusAAAAJ&hl=en'>
									<i className='fab fa-google fa-2x ml-3'></i>
								</a>
								<a href='https://www.linkedin.com/in/debajyoti-karmaker/'>
									<i className='fab fa-linkedin-in fa-2x ml-3'></i>
								</a>
								<a href='https://www.facebook.com/uqdkarma/'>
									<i className='fab fa-facebook fa-2x ml-3'></i>
								</a>
								<a href='skype:uqdkarma?chat'>
									<i className='fab fa-skype fa-2x ml-3'></i>
								</a>
								<a href='mailto: uqdkarma@gmail.com'>
									<i className='far fa-envelope-open fa-2x ml-3'></i>
								</a>
							</div>
							<p className='home-text'>
								I am a Research Fellow at Australian National University (ANU),
								currently hosted by Dr. Hanna Kurniwati. Before joining ANU, I
								completed my Ph.D. from The University of Queensland (UQ) on
								September, 2019, under the supervision of Prof. Mandyam V.
								Srinivasan. My research interests are in computer vision,
								machine learning, and deep learning. I am particularly
								interested in the areas of collision avoidance strategies,
								Robust Decision-making and Learning, and Object detection.
								Before starting my PhD, I was working as a lecturer at the
								American International University-Bangladesh (AIUB) - in the
								department of Computer Science. I also worked as a software
								engineer at Infra Blue Technology (IBT Games).
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Home;
